/**
 * Non-critical performance bootstrap.
 * Runs after DOM ready; does not replace theme.js custom elements.
 */
(function () {
  'use strict';

  if (!window.requestIdleCallback) {
    window.requestIdleCallback = function (callback, options) {
      var start = Date.now();
      return setTimeout(function () {
        callback({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          }
        });
      }, options && options.timeout ? 1 : 1);
    };
  }

  if (!window.cancelIdleCallback) {
    window.cancelIdleCallback = function (id) {
      clearTimeout(id);
    };
  }

  function lazyLoadDeferredIframes() {
    var iframes = document.querySelectorAll('iframe[data-src]');
    if (!iframes.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var iframe = entry.target;
          if (iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
          observer.unobserve(iframe);
        });
      },
      { rootMargin: '300px 0px' }
    );

    iframes.forEach(function (iframe) {
      observer.observe(iframe);
    });
  }

  function markVisibleSections() {
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.shopify-section');
    if (sections.length <= 1) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-section-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '150px 0px' }
    );

    sections.forEach(function (section, index) {
      if (index > 0) observer.observe(section);
    });
  }

  function deferNonCriticalWork() {
    requestIdleCallback(
      function () {
        lazyLoadDeferredIframes();
        markVisibleSections();
      },
      { timeout: 2000 }
    );
  }

  function onReady() {
    deferNonCriticalWork();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
